import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ServicesDeletedTableBodyRow from './Row';
import { getProvider, getType } from '../../../../../../utils/services';
import TableEmptySearch from '../../../../../../components/Table/EmptySearch';
import TableEmpty from '../../../../../../components/Table/TableEmpty';

const ServicesDeletedTableBody = ({ dispatch, services, types, checked, providers, filters, seeProviderColumn }) => {
  const { query, search_type } = filters;

  /**
   * Если нет найденных сервисов по поиску или фильтру, выводим заглушку
   */
  if (!services.length && (query || filters.providers || filters.type)) {
    return (
      <TableEmptySearch search={query} />
    )
  }

  /**
   * Если вообще нет сервисов
   */
  if (!services.length) {
    return (
      <TableEmpty description="No deleted services" />
    )
  }

  return services.map((service, index) => {
    const lastRow = services.length === index + 1;
    const type = getType(types, service.type)
    const isChecked = checked.includes(service.id);
    const provider = service.mode === 1 ? getProvider(providers, service.provider_id) : null;
    return (
      <ServicesDeletedTableBodyRow
        key={service.id}
        index={index}
        {...service}
        provider={provider}
        type={type}
        dispatch={dispatch}
        isChecked={isChecked}
        lastRow={lastRow}
        search={query}
        searchType={search_type}
        seeProviderColumn={seeProviderColumn}
      />
    )
  })
};

const arePropsEqual = (prevProps, nextProps) => !!nextProps.isLoadingTable;

ServicesDeletedTableBody.propTypes = {
  dispatch: PropTypes.func,
  services: PropTypes.array,
  types: PropTypes.array,
  checked: PropTypes.array,
  providers: PropTypes.array,
  filters: PropTypes.object,
  seeProviderColumn: PropTypes.bool,
}

export default memo(ServicesDeletedTableBody, arePropsEqual);
